import { useContext, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'contexts';

import { routes } from 'data/routes';

import { Input } from 'sections/Form';

const useForgotPassword = () => {
  const { handleSubmit, register } = useForm();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [stepTwo, stepTwoSet] = useState(false);
  const [email, emailSet] = useState('');
  const [error, errorSet] = useState('');

  const getCode = async (data: FieldValues) => {
    try {
      emailSet(data.email);
      await authContext.forgotPassword(data.email, () => stepTwoSet(true));
    } catch (err) {
      if (err instanceof Error) {
        errorSet(err?.message);
      } else {
        errorSet('error.unexpected');
      }
    }
  };

  const changePassword = async (data: FieldValues) => {
    if (data.password !== data.passwordConfirm) {
      errorSet('form.passwordsNotEqual');

      return;
    }

    try {
      await authContext.confirmPassword(email, data.code, data.password).then(() => {
        authContext.isNewPasswordSet(true);
        navigate(routes.home);
      });
    } catch (err) {
      if (err instanceof Error) {
        errorSet(err?.message);
      } else {
        errorSet('error.unexpected');
      }
    }
  };

  const inputs: Input[] = [
    {
      name: 'email',
      label: 'email:',
    },
  ];

  const secondaryInputs: Input[] = [
    {
      name: 'code',
      label: 'verification code:',
    },
    {
      name: 'password',
      label: 'new password:',
      type: 'password',
    },
    {
      name: 'passwordConfirm',
      label: 'confirm password:',
      type: 'password',
    },
  ];

  return {
    handleSubmit,
    register,
    getCode,
    changePassword,
    inputs,
    stepTwo,
    secondaryInputs,
    error,
  };
};

export { useForgotPassword };
